import { render, staticRenderFns } from "./ActiveSwitch.vue?vue&type=template&id=c83c75e4&"
import script from "./ActiveSwitch.vue?vue&type=script&lang=js&"
export * from "./ActiveSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports